var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowIncrease = function SvgArrowIncrease(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.07 9.194-.814-.793A.843.843 0 0 1 0 7.798c0-.226.092-.444.256-.604L7.38.25a.887.887 0 0 1 .62-.25c.231 0 .454.09.618.25l7.126 6.944c.165.16.257.378.257.604a.843.843 0 0 1-.257.603l-.813.793a.887.887 0 0 1-.632.248.905.905 0 0 1-.625-.262l-4.204-4.3v10.262a.836.836 0 0 1-.257.607.878.878 0 0 1-.623.251H7.416a.898.898 0 0 1-.623-.25.854.854 0 0 1-.257-.608V4.88l-4.208 4.3a.875.875 0 0 1-.626.267.895.895 0 0 1-.632-.253Z",
    fill: "#1C7CE5"
  })));
};
export default SvgArrowIncrease;